module.exports = __webpack_public_path__ + "media/images/mobile/title_gray_v-dd8d918a1d4c4979dcda3ef27481dde5.gif";